import { getApiHeaders } from '@/utils/Request';
/**
 * 卡片服务接口 - 处理卡片按钮点击后的请求
 * @param apiname API名称
 * @param session_id 会话ID
 * @param order_id 订单ID
 * @param onChunk 接收流式响应的回调函数
 * @param signal 可选的 AbortSignal 用于取消请求
 * @returns Promise<void>
 */
export const cardServices = async (
  apiname: string,
  session_id: number,
  order_id: string,
  onChunk: (chunk: string) => void,
  signal?: AbortSignal
): Promise<void> => {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/chat/cmd`, {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify({ apiname, session_id, order_id }),
      cache: 'no-cache',
      signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 获取响应体的Reader
    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('无法获取响应流');
    }

    // 用于处理流式数据的解码器
    const decoder = new TextDecoder('utf-8');
    let done = false;

    // 循环读取流数据
    while (!done) {
      const { value, done: readerDone } = await reader.read();
      done = readerDone;
      
      if (value) {
        // 解码数据并传递给回调函数
        const chunk = decoder.decode(value, { stream: true });
        onChunk(chunk);
      }
    }
  } catch (error: any) {
    if (error.name === 'AbortError') {
      return;
    }
    console.error('发送聊天消息失败:', error);
    throw new Error(error.message || '发送消息失败，请稍后重试');
  }
};